import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Permissions from "./pages/Permissions";
import SendNotification from "./pages/SendNotification";

const url = "https://demo-anghello-teams.davi.ai"; // "http://localhost:15151";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home url={url} />} />
        <Route path="/permissions" element={<Permissions url={url} />} />
        <Route path="/sendnotification" element={<SendNotification url={url} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
